export const environment = {
  general: {
    production: false,
    product: 'retail',
    title: 'Samate',
    url: 'https://backend.buhomanager.com:444/',
    nameMultiClient: 'samate',
    useMultiClient: false,
    logoUrl: 'https://buho-images.s3.sa-east-1.amazonaws.com/samate/smate-logo.svg',
    carouselImages: 0,
    carouselUrls: [
      'https://buho-images.s3.sa-east-1.amazonaws.com/samate/carrusel1.png',
      'https://buho-images.s3.sa-east-1.amazonaws.com/samate/carrusel2.webp',
    ],
    columnsItemMobile: 2,
    validateStock: false,
    mobileApp: false,
    paymentServiceUrl: 'http://localhost:9333',
  },
  bucketConfig: {
    region: 'sa-east-1',
    accessKey: '',
    secretAccessKey: '',
    bucketName: 'buho-images',
    bucketFolderToSavePhotos: 'multiclient/upload/photos-articles/',
    bucketFolderToSaveFiles: 'multiclient/upload/files/',
  },
  htmlContent: {
    separator: '',
  },
  mercadoPago: {
    useMercadoPago: true,
    tenderId: 92,
  },
  security: {
    encryptionKey: 'buho-retail-dev-key-2026-local',
  },
  localPayment: true,
  agreeWithSeller: true,
  shipping: {
    useShipping: true,
    correoArgentino: true,
    andreaniBranchPickup: false,
    correoArgentinoBranchPickup: false,
    defaultPackage: {
      weight: 500,
      height: 25,
      width: 25,
      length: 25,
    },
  },
  bankTransfer: false,
};
